"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.askForVoucher.name': 'Solicitud de Cupón',
    'tools.askForVoucher.description': 'Detecta solicitudes de cupones o descuentos en mensajes de usuario y activa acciones de cupón del lado del cliente',
};
